export default __webpack_public_path__ + "static/media/jbl-c100si-on-table.20582662.png";